import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  useColorMode
} from '@chakra-ui/react';

const ConfirmModal = ({
  isOpen,
  onClose,
  title = 'Confirm',
  message = 'Are you sure you want to proceed?',
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel'
}) => {
  const { colorMode } = useColorMode();

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent bg={colorMode === 'light' ? 'white' : 'gray.800'}>
        <ModalHeader color={colorMode === 'light' ? 'gray.800' : 'white'}>
          {title}
        </ModalHeader>
        <ModalCloseButton color={colorMode === 'light' ? 'gray.600' : 'gray.400'} />
        <ModalBody>
          <Text color={colorMode === 'light' ? 'gray.700' : 'gray.100'}>
            {message}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="ghost"
            mr={3}
            onClick={onCancel || onClose}
            color={colorMode === 'light' ? 'gray.600' : 'gray.300'}
            _hover={{
              bg: colorMode === 'light' ? 'gray.100' : 'gray.700'
            }}
          >
            {cancelText}
          </Button>
          <Button colorScheme="red" onClick={onConfirm}>
            {confirmText}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmModal;